import React, { useEffect } from 'react';
import cn from 'classnames';
import BondType, { INVENTORIES, BWICS, TBondType } from '@/creditflowresearch/domain/BondType';
import BwicCountLabel from '@/creditflowresearch/ui/components/bonds/common/BondTables/Bwic/BwicCountLabelContainer';
import InventoryCountLabel from '@/creditflowresearch/ui/components/bonds/common/BondTables/Inventory/InventoryCountLabelContainer';
import { TileTabsRow } from '@creditflowresearch/uilib/Tile';
import tabsStyles from '@creditflowresearch/uilib/styles/tabs.module.scss';

interface IProps {
  activeTab: TBondType,
  setActiveTab: (tab: TBondType) => void,
  isInventoryEmpty: boolean,
  isBwicEmpty: boolean,
}

const BondTypes = ({ activeTab, setActiveTab, isInventoryEmpty, isBwicEmpty }: IProps) => {
  useEffect(() => {
    if (isInventoryEmpty && !isBwicEmpty) {
      setActiveTab(BWICS);
    }
  }, [isInventoryEmpty]);

  const bwicClassNames = cn(tabsStyles.tab, {
    [tabsStyles.isTabActive]: BondType.isBwics(activeTab),
    [tabsStyles.isTabDisabled]: isBwicEmpty,
  });
  const inventoryClassNames = cn(tabsStyles.tab, {
    [tabsStyles.isTabActive]: BondType.isInventories(activeTab),
    [tabsStyles.isTabDisabled]: isInventoryEmpty,
  });

  return (
    <TileTabsRow dataTest="bondTypesDesktopTabs" overlap={ false }>
      <button
        type="button"
        className={ bwicClassNames }
        onClick={ () => setActiveTab(BWICS) }
        disabled={ isBwicEmpty }
        data-test="bondTypeActiveBwicsButton"
      >
        <span>BWICS</span>
        <BwicCountLabel className={ tabsStyles.tabCountLabel } />
      </button>
      <button
        type="button"
        className={ inventoryClassNames }
        onClick={ () => setActiveTab(INVENTORIES) }
        disabled={ isInventoryEmpty }
        data-test="bondTypeActiveInventoriesButton"
      >
        <span>Inventory</span>
        <InventoryCountLabel className={ tabsStyles.tabCountLabel } />
      </button>
    </TileTabsRow>
  );
};

export default BondTypes;
